// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".info-icon[data-v-e5849c0a]{margin-left:-5px;padding-right:5px}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Products/PartnerApiProducts/Edit.vue"],"names":[],"mappings":"AACA,4BAEI,gBAAA,CADA,iBACA","sourcesContent":["\n.info-icon {\n    padding-right: 5px;\n    margin-left: -5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
